import React from "react";
import {
  Card,
  CardMedia,
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";

import { styled } from "@mui/material/styles";
import Button, { ButtonProps } from "@mui/material/Button";
import { cardSx, mobileCardSx } from "utils";
import { getHighlightColorFromHex } from "context/themeContext";

const ColorButton = styled(Button)<ButtonProps>(({ theme }) => ({
  color: theme.palette.primary.contrastText,
  backgroundColor: theme.palette.primary.main,
  "&:hover": {
    backgroundColor: getHighlightColorFromHex(theme.palette.primary.main),
    color: theme.palette.getContrastText(
      getHighlightColorFromHex(theme.palette.primary.main),
    ),
  },
}));

const EmailVerification = () => {
  return (
    <Card
      raised
      sx={{
        backgroundColor: "white",
        flex: 1,
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <CardMedia
        alt="traxero"
        component="img"
        image="/traxero_logo.png"
        sx={{ mx: "auto", mb: 4, width: "90%" }}
      />
      <Typography variant="h3" align="center" sx={{ py: 2 }}>
        A verification Link has been sent to your E-mail account
      </Typography>
      <Typography variant="h5" align="center" sx={{ p: 6 }}>
        Please click on the link that has just been sent to your email account
        to verify your email and continue registration process
      </Typography>
      <Typography variant="h6" align="center">
        <ColorButton variant="contained" href="/login">
          Login
        </ColorButton>
      </Typography>
    </Card>
  );
};

export default EmailVerification;
